
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/toilet-installation",
      function () {
        return require("private-next-pages/services/toilet-installation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/toilet-installation"])
      });
    }
  